export default __webpack_public_path__ + "static/media/mapzen.4ddab83f.svg";